module.exports = __webpack_public_path__ + "static/img/2.fe31f4c2.jpg";